export const listAgentSkillsConfig = (agentId?: string) => ({
  url: `/superadmin/agent-skill`,
  params: agentId ? { agent_id: agentId } : {},
});

export const createAgentSkillConfig = () => ({
  url: `/superadmin/agent-skill`,
});

export const getAgentSkillConfig = (agentSkillId: string) => ({
  url: `/superadmin/agent-skill/${agentSkillId}`,
});

export const updateAgentSkillConfig = (agentSkillId: string) => ({
  url: `/superadmin/agent-skill/${agentSkillId}`,
});

export const deleteAgentSkillConfig = (agentSkillId: string) => ({
  url: `/superadmin/agent-skill/${agentSkillId}`,
});
